/**
 * Enum to represent each class of weather.
 * 
 * 0 - Sunny.
 * 1 - Partial. 
 * 2 - Clouds.
 * 3 - Rain.
 * 4 - Thunder.
 */
export enum WeatherState {
    SUNNY,
    PARTIAL,
    CLOUDS,
    RAIN,
    THUNDER
}


export interface HourlyWeather {
    hour: number,
    temp: number,
    weather: WeatherState
}


export function getTemperatures(h: number) {
    const nextDayTemps = [];
    const currentDayTemps = [];

    for (let i = 0; i < RANDOM_TEMPS.length; ++i) {
        if (i >= h) {
            currentDayTemps.push(RANDOM_TEMPS[i]);
        } else {
            nextDayTemps.push(RANDOM_TEMPS[i]);
        }
    }

    return [...currentDayTemps, ...nextDayTemps]
}


const RANDOM_TEMPS = [
    {
        hour: 0,
        temp: 4,
        weather: WeatherState.CLOUDS
    },
    {
        hour: 1,
        temp: 4,
        weather: WeatherState.CLOUDS
    },
    {
        hour: 2,
        temp: 5,
        weather: WeatherState.THUNDER
    },
    {
        hour: 3,
        temp: 5,
        weather: WeatherState.THUNDER
    },
    {
        hour: 4,
        temp: 5,
        weather: WeatherState.CLOUDS
    },
    {
        hour: 5,
        temp: 4,
        weather: WeatherState.CLOUDS
    },
    {
        hour: 6,
        temp: 4,
        weather: WeatherState.SUNNY
    },
    {
        hour: 7,
        temp: 4,
        weather: WeatherState.SUNNY
    },
    {
        hour: 8,
        temp: 5,
        weather: WeatherState.SUNNY
    },
    {
        hour: 9,
        temp: 6,
        weather: WeatherState.SUNNY
    },
    {
        hour: 10,
        temp: 6,
        weather: WeatherState.SUNNY
    },
    {
        hour: 11,
        temp: 7,
        weather: WeatherState.SUNNY
    },
    {
        hour: 12,
        temp: 7,
        weather: WeatherState.CLOUDS
    },
    {
        hour: 13,
        temp: 8,
        weather: WeatherState.CLOUDS
    },
    {
        hour: 14,
        temp: 8,
        weather: WeatherState.CLOUDS
    },
    {
        hour: 15,
        temp: 8,
        weather: WeatherState.CLOUDS
    },
    {
        hour: 16,
        temp: 7,
        weather: WeatherState.RAIN
    },
    {
        hour: 17,
        temp: 7,
        weather: WeatherState.RAIN
    },
    {
        hour: 18,
        temp: 7,
        weather: WeatherState.RAIN
    },
    {
        hour: 19,
        temp: 6,
        weather: WeatherState.RAIN
    },
    {
        hour: 20,
        temp: 6,
        weather: WeatherState.CLOUDS
    },
    {
        hour: 21,
        temp: 5,
        weather: WeatherState.CLOUDS
    },
    {
        hour: 22,
        temp: 5,
        weather: WeatherState.CLOUDS
    },
    {
        hour: 23,
        temp: 4,
        weather: WeatherState.CLOUDS
    }
];